import "../../../../App.css";

import {
  DownOutlined,
  LogoutOutlined,
  ProfileOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Col, Dropdown, MenuProps, Row, Space } from "antd";
import { MenuItemType } from "../selected-page-container/selected-page-container";
import { useNavigate } from "react-router";

interface UserDropdownProps {
  theme: string;
  username: string;
  handleLogout: () => void;
  handleProfileClick: () => void;
  items_paths: MenuItemType[];
}

export const UserDropdown = ({
  theme,
  username,
  handleLogout,
  handleProfileClick,
  items_paths
}: UserDropdownProps) => {
  const navigate = useNavigate();

  const dropdownButtons: MenuProps = {
    items: [
      {
        label: "Preferences",
        key: "0",
        icon: <SettingOutlined />,
        onClick: () => {
          navigate(items_paths[0].path)
        },
        className: "dropdown-item",
      },
      {
        label: "Logout",
        key: "1",
        icon: <LogoutOutlined />,
        onClick: handleLogout,
        className: "dropdown-item",
      },
      // {
      //   label: "Profile",
      //   key: "1",
      //   icon: <ProfileOutlined />,
      //   onClick: handleProfileClick,
      //   className: "dropdown-item",
      // },
     
    ],
  };

  const textColor = theme === "light" ? "#000000" : "#ffffff";

  return (
    <Row>
      <Col>
        <Dropdown menu={dropdownButtons} trigger={["click"]}>
          <Button style={{ border: "none", color: textColor }}>
            <Space>
              <UserOutlined />
              {username}
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
      </Col>
    </Row>
  );
};
